module.exports = __webpack_public_path__ + "media/images/sp/components/search/accordion/minus-ced69e3d13363180fa2d1ccf8f358b3c.svg";